module.exports = __webpack_public_path__ + "static/media/covid19ind.2971b52e.png";